import React, { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import { useLocation } from 'react-router-dom';
import { useClientList } from 'hooks/queries/package/clientQuery';
import { IClientProps } from 'utils/types/pacakageTypes';
import HeaderSection from 'components/container/HeaderSection';
import CollapseBox from 'components/table/CollapseBox';
import H3Title from 'components/etc/H3Title';
import DefaultButton from 'components/button/DefaultButton';
import ColorChip from './ColorChip';
import VersionSection from './VersionSection';
import ClientVersionTable from './ClientVersionTable';
import ClientDetailModal from './ClientDetailModal';
import { useTranslation } from 'react-i18next';
/**
 * * 패키지 관리 - 앱 > 클라이언트
 */

const ClientView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [visible, setVisible] = useState<boolean>(false);
  const [androidData, setAndroidData] = useState();
  const [iosData, setIosData] = useState();
  const [selectData, setSelectData] = useState<IClientProps>();
  const { data: clientList } = useClientList(
    location?.state?.record?.package_id,
  );

  const handleModalOpen = (record: any) => () => {
    setVisible(true);
    setSelectData(record);
  };

  useEffect(() => {
    const adList: any = [];
    const iosList: any = [];

    if (clientList) {
      clientList?.map((v, i) => {
        if (v.os_type === 'android') {
          adList.push(v);
        } else {
          iosList.push(v);
        }
        setAndroidData(adList);
        setIosData(iosList);
      });
    }
  }, [clientList]);
  return (
    <>
      <HeaderSection>
        <>
          <div className='title_box'>
            <H3Title>Android</H3Title>
            <div className='color_box'>
              <ColorChip color='#EED14C' />
              <ColorChip color='#fb8f37' />
              <p>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.clientContens.header.prepareVersion',
                )}
              </p>
            </div>
            <div className='color_box'>
              <ColorChip color='#88c637' />
              <ColorChip color='#2ab1a6' />
              <ColorChip color='#b7b7b7' />
              <ColorChip color='#7c7c7c' />
              <p>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.clientContens.header.liveVersion',
                )}
              </p>
            </div>
          </div>
          <div>
            <DefaultButton
              onClick={handleModalOpen({
                os_type: 'android',
                package_id: location?.state?.record?.package_id,
              })}
            >
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.clientContens.header.registerAndroid',
              )}
            </DefaultButton>
          </div>
        </>
      </HeaderSection>
      <CollapseBox defaultActiveKey={['1']}>
        <Collapse.Panel header='Google Play' key='1'>
          <VersionSection
            buttonData={androidData}
            handleModalOpen={handleModalOpen}
          />
        </Collapse.Panel>
        <Collapse.Panel
          header={t(
            'packageIDAppInformation.tabs.appContents.tabPane.clientContens.table.header.android',
          )}
          key='2'
        >
          <ClientVersionTable
            tableData={androidData}
            handleModalOpen={handleModalOpen}
          />
        </Collapse.Panel>
      </CollapseBox>

      <HeaderSection style={{ marginTop: '2.5rem' }}>
        <>
          <div className='title_box'>
            <H3Title>iOS</H3Title>

            <div className='color_box'>
              <ColorChip color='#EED14C' />
              <ColorChip color='#fb8f37' />
              <p>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.clientContens.header.prepareVersion',
                )}
              </p>
            </div>
            <div className='color_box'>
              <ColorChip color='#88c637' />
              <ColorChip color='#2ab1a6' />
              <ColorChip color='#b7b7b7' />
              <ColorChip color='#7c7c7c' />
              <p>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.clientContens.header.liveVersion',
                )}
              </p>
            </div>
          </div>
          <DefaultButton
            onClick={handleModalOpen({
              os_type: 'ios',
              package_id: location?.state?.record?.package_id,
            })}
          >
            {t(
              'packageIDAppInformation.tabs.appContents.tabPane.clientContens.header.registerIOS',
            )}
          </DefaultButton>
        </>
      </HeaderSection>
      <CollapseBox defaultActiveKey={['3']}>
        <Collapse.Panel header='App Store' key='3'>
          <VersionSection
            buttonData={iosData}
            handleModalOpen={handleModalOpen}
          />
        </Collapse.Panel>
        <Collapse.Panel
          header={t(
            'packageIDAppInformation.tabs.appContents.tabPane.clientContens.table.header.iOS',
          )}
          key='4'
        >
          <ClientVersionTable
            tableData={iosData}
            handleModalOpen={handleModalOpen}
          />
        </Collapse.Panel>
      </CollapseBox>

      {/* 클라이언트 상세 정보 모달 */}
      <ClientDetailModal
        visible={visible}
        setVisible={setVisible}
        selectData={selectData}
      />
    </>
  );
};

export default ClientView;
